/* Layout */
import Layout from "@/layout"

export const pubRouter = [
  {
    path: "/redirect",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/redirect/:path*",
        component: () => import("@/views/redirect/index")
      }
    ]
  },
  {
  path: '/test/questionnaire-concurrency',
  name: 'QuestionnaireConcurrency',
  component: () => import('@/views/test/questionnaire-concurrency.vue'),
  meta: { title: '问卷并发测试', icon: 'el-icon-warning' }
},
  // { path: '/', redirect: '/login' },
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true
  },
  {
    path: "/quicklogin",
    component: () => import("@/views/login/quicklogin"),
    hidden: true
  },
  {
    path: "/auth-redirect",
    component: () => import("@/views/login/authredirect"),
    hidden: true
  },
  {
    path: "/loginedu",
    component: () => import("@/views/login/loginedu"),
    hidden: true
  },
  {
    path: "/404",
    component: () => import("@/views/errorPage/404"),
    hidden: true
  },
  {
    path: "/",
    name: "setting",
    component: Layout,
    hidden: true,
    meta: { title: "基本信息", icon: "account" },
    children: [
      {
        path: "setting",
        component: () => import("@/views/login/setting"),
        meta: { title: "账号设置", icon: "setting" }
      }
    ]
  },

  {
    path: "/introduce",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "",
        name: "introduce",
        component: () => import("@/views/login/introduce"),
        meta: { title: "功能介绍", icon: "introduce" }
      },
      {
        path: "/updateLog",
        name: "updateLog",
        component: () => import("@/views/login/updateLog"),
        meta: { title: "更新日志", icon: "" }
      },
      {
        path: "/updateLog/detail",
        name: "updateLogDetail",
        component: () => import("@/views/login/updateLogDetail"),
        meta: { title: "更新日志详情", icon: "" }
      }
    ]
  },
  { path: "/file", redirect: "/setting" },
  { path: "", redirect: "/setting" }
]
export default pubRouter
